








































































































import StringSimilarity from "string-similarity";
import { defineComponent, ref, watch } from "@vue/composition-api";

import { getNames } from "@/tools/msa/utils/names";
import { Document, Session } from "@/tools/msa/models";
import DateInput from "@/tools/msa/components/inputs/DateInput.vue";
import { getAllPatientNames } from "@/tools/msa/utils/names/patient";
import NameInput from "@/tools/msa/components/inputs/NameInput.vue";
import PredictiveInput from "@/tools/msa/components/PredictiveInput.vue";

const calculatePossiblePractice = (session: Session, provider: string) => {
  const map = new Map(
    session.documents
      .filter(
        document =>
          document.practice.length > 0 && document.providerName.length > 0
      )
      .map(document => [document.providerName.trim(), document.practice.trim()])
  );
  if (map.size === 0) return "";

  const matches = StringSimilarity.findBestMatch(provider.trim(), [
    ...map.keys()
  ]);
  return matches.bestMatch.rating > 0.67
    ? map.get(matches.bestMatch.target)!
    : "";
};

interface Props {
  session: Session;
  document: Document;
}

export default defineComponent<Props>({
  name: "MetadataForm",
  components: { PredictiveInput, NameInput, DateInput },
  props: {
    session: { type: Object, required: true },
    document: { type: Object, required: true }
  },
  setup(props: Props) {
    const patientNames = ref<string[]>([]);

    const providerNames = ref<string[]>([]);

    const practices = ref<string[]>([]);

    watch(
      () => props.session,
      () => (patientNames.value = getAllPatientNames(props.session)),
      { immediate: true }
    );

    watch(
      () => props.document,
      () => {
        providerNames.value = [
          ...new Set([
            ...getNames(props.document, "name.drname"),
            ...props.session.documents
              .map(document => document.providerName.trim())
              .filter(Boolean)
          ])
        ];

        if (
          props.document.providerName.length > 0 &&
          props.document.practice.length === 0
        ) {
          props.document.practice = calculatePossiblePractice(
            props.session,
            props.document.providerName
          );
        }

        practices.value = [
          ...new Set(
            props.session.documents
              .map(document => document.practice.trim())
              .filter(Boolean)
          )
        ];
      },
      { immediate: true }
    );

    return { practices, patientNames, providerNames };
  }
});
